// extracted by mini-css-extract-plugin
module.exports = {"giftwrap":"landing_giftwrap__2EBYe","moreInfoButton":"landing_moreInfoButton__eMFex","acceptVoucherButton":"landing_acceptVoucherButton__1FdmU"};